export default __webpack_public_path__ + "static/media/AIA.e826398d.svg";